// Define free shipping thresholds based on country (in cents)
const FREE_SHIPPING_THRESHOLDS = {
  NZ: 24900, // $249.00 NZD for New Zealand
  AU: 9900  // $99.00 AUD for Australia
};

// Country code to name mapping for international shipping message
const COUNTRY_NAMES = {
  US: 'United States',
  NZ: 'New Zealand',
  AU: 'Australia',
  // Add more countries as needed
  default: 'your country' // Fallback for unknown country codes
};

// Function to get the free shipping threshold based on Shopify country
function getFreeShippingThreshold(country) {
  return Object.prototype.hasOwnProperty.call(FREE_SHIPPING_THRESHOLDS, country)
    ? FREE_SHIPPING_THRESHOLDS[country]
    : null;
}

// Function to get the country name and preposition for display
function getCountryName(country) {
  if (country === 'NZ') {
    return { name: 'New Zealand', preposition: 'to' };
  }
  return { name: 'Australia', preposition: 'within' }; // Default to AU for simplicity
}

// Function to get the display name for a country code
function getCountryDisplayName(country) {
  return COUNTRY_NAMES[country] || COUNTRY_NAMES.default;
}

function checkShipping(subtotal) {
  const freeShippingElement = document.querySelector(".free_shipping");

  if (!freeShippingElement) return; // Exit if the element doesn't exist

  const country = Shopify?.country || 'AU'; // Fallback to AU if Shopify.country is unavailable
  const FREE_SHIPPING_THRESHOLD = getFreeShippingThreshold(country);

// Handle countries with NO threshold defined (i.e. null/undefined)
if (FREE_SHIPPING_THRESHOLD === null || FREE_SHIPPING_THRESHOLD === undefined) {
  let formattedAmount;
  try {
    formattedAmount = theme.Currency.formatMoney(2000, theme.settings.moneyWithCurrencyFormat);
    formattedAmount = formattedAmount.replace(/AUD|NZD/g, 'USD'); // Override currency if needed
  } catch (error) {
    formattedAmount = "$20.00 USD";
  }

  if (country !== 'US' && country !== 'NZ' && country !== 'AU') {
    freeShippingElement.innerHTML =
      "<div>Shipping is <strong>" +
      formattedAmount +
      "</strong> Worldwide.</div>" +
      "<div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:100%'></div></div>";
  } else {
    const countryName = getCountryDisplayName(country);
    freeShippingElement.innerHTML =
      "<div>Shipping is <strong>" +
      formattedAmount +
      "</strong> to " + countryName + ".</div>" +
      "<div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:100%'></div></div>";
  }
  return;
}

  const { name: countryName, preposition } = getCountryName(country);
  const percent = subtotal / (FREE_SHIPPING_THRESHOLD / 100);
  const remaining = Math.round(FREE_SHIPPING_THRESHOLD - subtotal);

  if (subtotal < FREE_SHIPPING_THRESHOLD) {
    let formattedRemaining;
    try {
      formattedRemaining = theme.Currency.formatMoney(remaining, theme.settings.moneyWithCurrencyFormat);
    } catch (error) {
      formattedRemaining = `${remaining / 100} ${country === 'NZ' ? 'NZD' : 'AUD'}`; // Fallback if formatting fails
    }
    freeShippingElement.innerHTML =
      "<div>You're <strong>" +
      formattedRemaining +
      "</strong> from <strong>Free Express Shipping </strong> " + preposition + " " + countryName + ".</div>" +
      "<div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:" +
      percent +
      "%'></div></div>";
  } else {
    freeShippingElement.innerHTML =
      "<div>Yew! 🤙🏼 <strong>Free Express Shipping </strong>" + preposition + " " + countryName + ".</div>" +
      "<div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:100%'></div></div>";
  }
}

// Gift bar config comes from the theme customizer (output inline in cart-drawer.liquid as
// window.MALOSI_GIFT_BAR). Fallbacks keep it working if the inline config is ever missing.
function getGiftConfig() {
  const cfg = window.MALOSI_GIFT_BAR || {};
  return {
    enabled: cfg.enabled !== false,
    threshold: typeof cfg.threshold === 'number' && cfg.threshold > 0 ? cfg.threshold : 12000, // cents
    textBefore: cfg.textBefore || "You're [amount] from free chopsticks 🥢",
    textUnlocked: cfg.textUnlocked || "Yew! 🤙🏼 You've unlocked free chopsticks! 🥢",
    variantId: cfg.variantId || 0,
    autoAdd: cfg.autoAdd === true
  };
}

// Auto-add fires at most once per browser session (persisted via sessionStorage), so after the
// gift is auto-added the customer can remove it and it won't be silently re-added — instead the
// manual upsell card reappears. `giftAutoAddInFlight` guards against the several cart events that
// can land in quick succession (cart:updated, drawer-open mutation) double-firing the request.
let giftAutoAddInFlight = false;

function giftSessionKey(variantId) {
  return "malosi_gift_autoadded_" + variantId;
}

function hasAutoAddedThisSession(variantId) {
  try {
    return sessionStorage.getItem(giftSessionKey(variantId)) === "1";
  } catch (e) {
    return false; // Private mode / storage blocked — fall back to never auto-adding
  }
}

function markAutoAddedThisSession(variantId) {
  try {
    sessionStorage.setItem(giftSessionKey(variantId), "1");
  } catch (e) {}
}

function autoAddGift(variantId) {
  if (giftAutoAddInFlight || !variantId) return;
  giftAutoAddInFlight = true;
  markAutoAddedThisSession(variantId); // Mark up front so a second event can't queue a duplicate add
  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
    .then(r => r.json())
    .then(() => {
      document.dispatchEvent(new CustomEvent("cart:build")); // Rebuild drawer to show the line item
    })
    .catch(() => {})
    .finally(() => { giftAutoAddInFlight = false; });
}

// Show the free-gift upsell card once the threshold is reached, but only while the gift isn't
// already in the cart. `items` is optional — when a cart object is already on hand (e.g. from a
// cart:updated event) we use it; otherwise we fetch /cart.js.
function updateGiftUpsell(thresholdMet, variantId, items, autoAdd) {
  const card = document.querySelector(".free_gift_upsell");
  if (!card) return; // No gift product selected in the customizer

  if (!thresholdMet) {
    card.hidden = true;
    return;
  }

  const toggle = (cartItems) => {
    const inCart = cartItems.some(item => item.id === variantId);

    // First time the threshold is hit this session (and the gift isn't already in the cart),
    // auto-add it so the customer can simply check out with the free product. The card stays
    // hidden because it's about to appear as a line item. On any subsequent removal the session
    // flag is already set, so we fall through to the manual upsell card below.
    if (autoAdd && !inCart && !hasAutoAddedThisSession(variantId)) {
      autoAddGift(variantId);
      card.hidden = true;
      return;
    }

    card.hidden = inCart; // Hide once it's in the cart, show again if removed
  };

  if (Array.isArray(items)) {
    toggle(items);
  } else {
    fetch('/cart.js')
      .then(r => r.json())
      .then(cart => toggle(cart.items))
      .catch(() => {});
  }
}

function checkGift(subtotal, cartItems) {
  const giftElement = document.querySelector(".free_gift");

  if (!giftElement) return; // Exit if the element doesn't exist (bar disabled in customizer)

  const cfg = getGiftConfig();
  if (!cfg.enabled) { giftElement.innerHTML = ""; return; }

  const percent = subtotal / (cfg.threshold / 100);
  const remaining = Math.round(cfg.threshold - subtotal);
  const thresholdMet = subtotal >= cfg.threshold;

  if (!thresholdMet) {
    let formattedRemaining;
    try {
      formattedRemaining = theme.Currency.formatMoney(remaining, theme.settings.moneyWithCurrencyFormat);
    } catch (error) {
      formattedRemaining = `$${(remaining / 100).toFixed(2)}`; // Fallback if formatting fails
    }
    const message = cfg.textBefore.replace('[amount]', '<strong>' + formattedRemaining + '</strong>');
    giftElement.innerHTML =
      "<div>" + message + "</div>" +
      "<div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:" +
      percent +
      "%'></div></div>";
  } else {
    giftElement.innerHTML =
      "<div>" + cfg.textUnlocked + "</div>" +
      "<div class='pn-progressbar'><div class='pn-progressbar_ind' style='width:100%'></div></div>";
  }

  // Show/hide the free-gift upsell card below the progress bar (and auto-add when enabled)
  updateGiftUpsell(thresholdMet, cfg.variantId, cartItems, cfg.autoAdd);
}

// Add the gift product to the cart when the upsell card's "Add" button is clicked.
document.addEventListener("click", function (e) {
  const btn = e.target.closest(".free_gift_upsell__add");
  if (!btn) return;

  const id = btn.getAttribute("data-variant-id");
  if (!id) return;

  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: id, quantity: 1 })
  })
    .then(r => r.json())
    .then(() => {
      const card = btn.closest(".free_gift_upsell");
      if (card) card.hidden = true; // Disappears once added
      document.dispatchEvent(new CustomEvent('cart:build')); // Rebuild drawer to show the line item
    })
    .catch(() => {})
    .finally(() => { btn.disabled = false; });
});

// Keep the bars and the upsell card in sync live whenever the cart changes (add/remove/qty),
// so removing the gift re-shows the upsell without needing to reopen the drawer.
document.addEventListener("cart:updated", function (e) {
  const cart = e.detail && e.detail.cart;
  if (!cart) return;
  checkShipping(cart.total_price);
  checkGift(cart.total_price, cart.items);
});

// Remove a line item when its bin icon is clicked in the cart drawer, without leaving the page.
document.addEventListener("click", function (e) {
  const link = e.target.closest("#CartDrawer [data-cart-remove]");
  if (!link) return;
  e.preventDefault();
  const item = link.closest(".cart__item");
  if (item) {
    if (item.classList.contains("is-removing")) return;
    item.classList.add("is-removing");
  }
  fetch("/cart/change.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id: link.dataset.cartRemove, quantity: 0 })
  })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.dispatchEvent(new CustomEvent("cart:build")); // Rebuild drawer line items + totals
      document.dispatchEvent(new CustomEvent("cart:updated", { detail: { cart: cart } }));
    })
    .catch(function () {
      if (item) item.classList.remove("is-removing");
    });
});

// Select the cart drawer element
const cartDrawer = document.getElementById("CartDrawer");

// Callback function to run when mutations are observed
const observerCallback = function (mutationsList) {
  for (let mutation of mutationsList) {
    if (mutation.type === "attributes" && mutation.attributeName === "class") {
      if (cartDrawer.classList.contains("drawer--is-open")) {
        const subtotalElement = cartDrawer.querySelector("[data-subtotal]");
        if (!subtotalElement) {
          return; // Exit if subtotal element is missing
        }
        const subtotalElementContent = subtotalElement.textContent.trim();
        const subtotalMatch = subtotalElementContent.match(/[0-9]+[,.]?[0-9]*/); // Extract numeric part
        if (!subtotalMatch) {
          return; // Exit if no numeric value found
        }
        const subtotalValue = Math.round(
          parseFloat(subtotalMatch[0].replace(/[,]/g, '')) * 100
        ); // Convert to cents, remove commas
        checkShipping(subtotalValue);
        checkGift(subtotalValue);
      }
    }
  }
};

// Create a MutationObserver instance to watch for changes in the cart drawer
const drawerObserver = new MutationObserver(observerCallback);

// Start observing the cart drawer for changes in its class attribute
if (cartDrawer) {
  drawerObserver.observe(cartDrawer, {
    attributes: true,
    attributeFilter: ["class"],
  });
}

// Dynamically change Micro Size URLs
document.addEventListener('DOMContentLoaded', function() {
  const colorInputs = document.querySelectorAll('input[name="Color"]');
  const sizeLinks = document.querySelectorAll('.variant-input-wrap .variant-input');

  function updateSizeLinks(selectedColor) {
    sizeLinks.forEach(sizeLink => {
      if (sizeLink.dataset.baseUrl) { // Only update for Micro products
        const sizeVariants = sizeLink.getAttribute('data-variants');
        const variantsArray = sizeVariants.split(',');
        let variantId = '';

        variantsArray.forEach(variant => {
          const [color, id] = variant.split(':');
          if (color === selectedColor) {
            variantId = id;
          }
        });

        const baseUrl = sizeLink.getAttribute('data-base-url');
        sizeLink.href = `${baseUrl}?variant=${variantId}`;
      }
    });
  }

  colorInputs.forEach(colorInput => {
    colorInput.addEventListener('change', function() {
      const selectedColor = this.getAttribute('data-color-name');
      updateSizeLinks(selectedColor);
    });
  });

  sizeLinks.forEach(sizeLink => {
    sizeLink.addEventListener('click', function(event) {
      const selectedColorInput = document.querySelector('input[name="Color"]:checked');
      const selectedColor = selectedColorInput ? selectedColorInput.getAttribute('data-color-name') : null;
      if (selectedColor && sizeLink.dataset.baseUrl) { // Only update for Micro products
        updateSizeLinks(selectedColor);
      }
    });
  });

  // Trigger initial update on page load
  const selectedColorInput = document.querySelector('input[name="Color"]:checked');
  if (selectedColorInput) {
    const selectedColor = selectedColorInput.getAttribute('data-color-name');
    updateSizeLinks(selectedColor);
  }
});

// Function to set up the CM/IN toggle functionality
function setupSizeChartToggle(tooltip) {
  const cmButton = tooltip.querySelector("#cmButton");
  const inButton = tooltip.querySelector("#inButton");
  const centimetresTable = tooltip.querySelector("#centimetresTable");
  const inchesTable = tooltip.querySelector("#inchesTable");

  if (!cmButton || !inButton || !centimetresTable || !inchesTable) {
    return;
  }

  // Remove existing listeners by cloning the buttons
  cmButton.replaceWith(cmButton.cloneNode(true));
  inButton.replaceWith(inButton.cloneNode(true));

  const newCmButton = tooltip.querySelector("#cmButton");
  const newInButton = tooltip.querySelector("#inButton");

  // Attach event listeners to the toggle buttons
  newCmButton.addEventListener("click", function () {
    showCM(newCmButton, newInButton, centimetresTable, inchesTable);
  });

  newInButton.addEventListener("click", function () {
    showIN(newCmButton, newInButton, centimetresTable, inchesTable);
  });
}

// Function to show the centimetres table
function showCM(cmButton, inButton, centimetresTable, inchesTable) {
  centimetresTable.style.display = "block";
  inchesTable.style.display = "none";
  cmButton.classList.add("selected");
  inButton.classList.remove("selected");
}

// Function to show the inches table
function showIN(cmButton, inButton, centimetresTable, inchesTable) {
  centimetresTable.style.display = "none";
  inchesTable.style.display = "block";
  inButton.classList.add("selected");
  cmButton.classList.remove("selected");
}

document.addEventListener('DOMContentLoaded', function () {
  // Initialize toggle functionality on the product page (static elements)
  setupSizeChartToggle(document);

  // Handle dynamic tooltip toggles
  const tooltipTrigger = document.querySelector('tool-tip-trigger[data-tool-tip="size-chart"]');
  if (tooltipTrigger) {
    tooltipTrigger.addEventListener("click", function () {
      // Wait for the tooltip to open
      const tooltipCheckInterval = setInterval(() => {
        const tooltip = document.querySelector('tool-tip[data-tool-tip="size-chart"][data-tool-tip-open="true"]');
        if (tooltip) {
          clearInterval(tooltipCheckInterval); // Stop checking
          setupSizeChartToggle(tooltip); // Initialize toggle functionality for the tooltip
        }
      }, 50); // Check every 50ms
    });
  }

  var videoElements = document.querySelectorAll('video');

  videoElements.forEach(function(videoElement) {
    videoElement.controls = false;

    videoElement.addEventListener('play', function () {
      this.controls = false;
    });

    videoElement.addEventListener('pause', function () {
      this.controls = false;
    });
  });
});

/* ============================================================
   Mobile Sticky Add-to-Cart Bar
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {
  var stickyBar = document.querySelector('[data-sticky-atc]');
  if (!stickyBar || !window.theme || !theme.config) return;
  if (!theme.config.bpSmall) return;

  var formId = stickyBar.dataset.formId;
  var form = document.getElementById(formId);
  if (!form) return;

  var container = stickyBar.closest('[data-section-type="product"]');
  if (!container) return;

  var originalBtn = form.querySelector('[data-add-to-cart]');
  if (!originalBtn) return;

  var els = {
    image: stickyBar.querySelector('[data-sticky-atc-image]'),
    variant: stickyBar.querySelector('[data-sticky-atc-variant]'),
    price: stickyBar.querySelector('[data-sticky-atc-price]'),
    btn: stickyBar.querySelector('[data-sticky-atc-btn]'),
    btnText: stickyBar.querySelector('[data-sticky-atc-btn-text]')
  };

  /* Visibility via IntersectionObserver */
  /* Use negative top rootMargin to account for sticky header height */
  var headerH = 0;
  var header = document.querySelector('.site-header');
  if (header) headerH = header.offsetHeight + 10;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      } else if (entry.boundingClientRect.top < headerH) {
        stickyBar.classList.add('is-visible');
        stickyBar.setAttribute('aria-hidden', 'false');
      } else {
        stickyBar.classList.remove('is-visible');
        stickyBar.setAttribute('aria-hidden', 'true');
      }
    });
  }, { threshold: 0, rootMargin: '-' + headerH + 'px 0px 0px 0px' });

  observer.observe(originalBtn);

  /* ATC click — submit the real form */
  els.btn.addEventListener('click', function () {
    if (els.btn.disabled) return;
    form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  });

  /* Mirror loading state from original button */
  var loadingObs = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.attributeName === 'class') {
        els.btn.classList.toggle('btn--loading', originalBtn.classList.contains('btn--loading'));
      }
    });
  });
  loadingObs.observe(originalBtn, { attributes: true, attributeFilter: ['class'] });

  /* Variant sync */
  container.addEventListener('variantChange', function (evt) {
    var variant = evt.detail ? evt.detail.variant : null;
    if (!variant) {
      els.btn.disabled = true;
      if (els.btnText) els.btnText.textContent = theme.strings.unavailable || 'Unavailable';
      return;
    }
    if (els.variant) els.variant.textContent = variant.title !== 'Default Title' ? variant.title : '';
    if (els.image && variant.featured_image) {
      els.image.src = theme.Images
        ? theme.Images.getSizedImageUrl(variant.featured_image.src, '80x80_crop_center')
        : variant.featured_image.src;
    }
    var origText = originalBtn.querySelector('[data-add-to-cart-text]');
    if (variant.available) {
      els.btn.disabled = false;
      if (els.btnText && origText) els.btnText.textContent = origText.dataset.defaultText || 'Add to Cart';
    } else {
      els.btn.disabled = true;
      if (els.btnText) els.btnText.textContent = theme.strings.soldOut || 'Sold Out';
    }
  });

  /* Price sync */
  container.addEventListener('variantPriceChange', function (evt) {
    var variant = evt.detail ? evt.detail.variant : null;
    if (variant && els.price) {
      els.price.innerHTML = theme.Currency.formatMoney(variant.price, theme.settings.moneyFormat);
    }
  });

  /* Breakpoint changes */
  document.addEventListener('unmatchSmall', function () {
    stickyBar.classList.remove('is-visible');
    stickyBar.setAttribute('aria-hidden', 'true');
    observer.disconnect();
  });
  document.addEventListener('matchSmall', function () {
    observer.observe(originalBtn);
  });
});

// Product page rating badge: replace Judge.me's "X reviews" text with "4.9/5 Based on X reviews".
// Judge.me re-renders the badge after load, so the text is re-applied whenever it changes.
(function () {
  function ratingText(badge) {
    const rating = parseFloat(badge.dataset.averageRating);
    const count = parseInt(badge.dataset.numberOfReviews, 10);
    if (!rating || !count) return null;
    const score = String(Math.round(rating * 10) / 10);
    return score + "/5 Based on " + count + (count === 1 ? " review" : " reviews");
  }

  function updateBadges() {
    document.querySelectorAll(".product-single__meta .jdgm-prev-badge").forEach(function (badge) {
      const textEl = badge.querySelector(".jdgm-prev-badge__text");
      const text = ratingText(badge);
      if (!textEl || !text || textEl.textContent.trim() === text) return;
      textEl.textContent = text;
      textEl.classList.add("jdgm-prev-badge__text--summary");
    });
  }

  function init() {
    const meta = document.querySelector(".product-single__meta");
    if (!meta) return;
    updateBadges();
    new MutationObserver(updateBadges).observe(meta, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();

// Product page review highlight (under Add to Cart): picks one high-quality review from the
// Judge.me reviews already on the page. A review qualifies when it is 5 stars, from a verified
// buyer, and its text is a readable length. Among those, reviews for this exact product, with a
// customer photo, and closest to the ideal length are preferred. Nothing shows if none qualify.
(function () {
  const MIN_LENGTH = 60;
  const MAX_LENGTH = 260;
  const IDEAL_LENGTH = 140;

  const STAR = '<svg aria-hidden="true" focusable="false" viewBox="0 0 20 20"><path d="M10 1.8l2.5 5.2 5.7.8-4.1 4 1 5.7L10 14.8l-5.1 2.7 1-5.7-4.1-4 5.7-.8z"/></svg>';

  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function readReview(el) {
    const ratingEl = el.querySelector(".jdgm-rev__rating");
    const bodyEl = el.querySelector(".jdgm-rev__body");
    if (!ratingEl || !bodyEl) return null;
    return {
      score: parseInt(ratingEl.dataset.score, 10),
      verified: el.dataset.verifiedBuyer === "true",
      body: bodyEl.textContent.replace(/\s+/g, " ").trim(),
      author: (el.querySelector(".jdgm-rev__author") || {}).textContent || "",
      productUrl: el.dataset.productUrl || "",
      hasPhoto: !!el.querySelector(".jdgm-rev__pic-link")
    };
  }

  function pickReview(reviews, productUrl) {
    let best = null;
    let bestPoints = -Infinity;
    reviews.forEach(function (r) {
      if (!r || r.score !== 5 || !r.verified) return;
      if (r.body.length < MIN_LENGTH || r.body.length > MAX_LENGTH) return;
      let points = 0;
      if (r.productUrl === productUrl) points += 3;
      if (r.hasPhoto) points += 1;
      points -= Math.abs(r.body.length - IDEAL_LENGTH) / 100;
      if (points > bestPoints) {
        bestPoints = points;
        best = r;
      }
    });
    return best;
  }

  function init() {
    const holder = document.querySelector("[data-review-highlight]");
    if (!holder) return;
    const reviews = Array.prototype.map.call(document.querySelectorAll(".jdgm-rev"), readReview);
    const review = pickReview(reviews, holder.dataset.productUrl);
    if (!review) return;

    const meta = [];
    if (review.author.trim()) meta.push("<strong>" + escapeHtml(review.author.trim()) + "</strong>");
    meta.push("Verified buyer");

    let stars = "";
    for (let i = 1; i <= 5; i++) {
      stars += i <= review.score ? STAR.replace("<svg ", '<svg class="is-filled" ') : STAR;
    }

    holder.innerHTML =
      '<div class="review-highlight__stars" role="img" aria-label="' + review.score + ' out of 5 stars">' + stars + "</div>" +
      '<blockquote class="review-highlight__body">&ldquo;' + escapeHtml(review.body) + "&rdquo;</blockquote>" +
      '<div class="review-highlight__meta">' + meta.join(" <span aria-hidden=\"true\">&middot;</span> ") + "</div>";
    holder.hidden = false;
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
